import IconLogo from './icon_logo_black.svg';
import s from './index.module.scss';

export const GreyLayout = ({ children }) => {
  return (
    <div className={s.layout}>
      <header className={s.header}>
        <div className={s.container}>
          <img src={IconLogo} alt="logo" width={90} height={16} />
        </div>
      </header>
      <div className={s.content}>{children}</div>
    </div>
  );
};
